import { useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/auth/authStore";
import { AppSidebar, MenuItem } from "@/shared/components/layout/AppSidebar";
import { TopBar } from "@/shared/components/layout/TopBar";


export function ProtectedRoute() {
  const status = useAuthStore((s) => s.status);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  if (status === "idle" || status === "authenticating") {
    return (
      <div className="h-screen flex-center bg-gradient-premium" style={{ color: "#fff", fontSize: "1.2rem" }}>
        <div className="text-center">
          <div className="mb-4" style={{ fontSize: "3rem", animation: "pulse 2s infinite" }}>⚙️</div>
          <div>در حال بررسی نشست کاربری...</div>
        </div>
      </div>
    );
  }

  if (status !== "authenticated") {
    return <Navigate to="/login" replace />;
  }

  const user = useAuthStore.getState().user;
  const hasInvPerm = user?.permissions?.includes("inventory.view") || user?.roles?.includes("admin");
  const hasProdPerm = user?.permissions?.includes("production.view") || user?.roles?.includes("admin");
  const hasQualPerm = user?.permissions?.includes("quality.view") || user?.roles?.includes("admin");
  const hasPlanPerm = user?.permissions?.includes("planning.view") || user?.roles?.includes("admin");



  const menuItems: (MenuItem & { key?: string })[] = [

    {
      key: "orders_lines",
      title: "سفارشات و خطوط تولید",
      icon: "⚡",
      children: [
        { title: "خطوط و دستگاه‌ها", path: "/production/lines", icon: "🏭" },
        { title: "لیست سفارشات تولید", path: "/production/orders", icon: "📋" },
        { title: "سفارش تولید جدید", path: "/production/orders/create", icon: "⚡" },
        { title: "مسیریابی تولید (Routing)", path: "/routing", icon: "🗺️" },
      ]
    },
    {
      key: "product_bom",
      title: "مهندسی محصول و BOM",
      icon: "🛠️",
      children: [
        { title: "خانواده‌های BOM", path: "/bom/families", icon: "📋" },
        { title: "ایجاد خانواده BOM", path: "/bom/families/create", icon: "🏗️" },
        { title: "تخصیص قطعات به ایستگاه‌ها", path: "/bom/allocations", icon: "🔗" },
        { title: "مدیریت فیلدهای سفارشی", path: "/forms/custom-fields", icon: "🏷️" },
      ]
    },
    {
      key: "shopfloor_shifts",
      title: "اجرای کارگاه و شیفت‌ها",
      icon: "⏸️",
      children: [
        { title: "توقفات تجهیزات (Downtime)", path: "/production/shopfloor/downtime", icon: "⏸️" },
        { title: "دستورالعمل‌های کاری", path: "/production/shopfloor/work-instructions", icon: "📋" },
        { title: "مدیریت رسترها", path: "/production/shopfloor/rosters", icon: "📅" },
        { title: "تخصیص شیفت/رستر", path: "/production/shopfloor/roster-assignments", icon: "👥" },
        { title: "درخواست‌های مرخصی", path: "/production/shopfloor/leave-requests", icon: "🏖️" },
        { title: "جابجایی شیفت‌ها", path: "/production/shopfloor/shift-swaps", icon: "🔄" },
        { title: "تخصیص ایستگاه/دستگاه", path: "/production/station-assignments", icon: "🏭" },
      ]
    },
    {
      key: "material_holds",
      title: "مصرف قطعات و ناقصی‌ها",
      icon: "🔧",
      children: [
        { title: "ثبت مصرف قطعات", path: "/production/consumption", icon: "🔧" },
        { title: "ثبت ضایعات تولید", path: "/production/scrap", icon: "🗑️" },
        { title: "انبار ناقصی‌ها (Hold)", path: "/production/shortage-holds", icon: "📦" },
        { title: "پیش‌خوان کیفیت (QC)", path: "/quality", icon: "🛡️" },
      ]
    },
    {
      key: "serialization",
      title: "سریال‌سازی و ردگیری",
      icon: "🏷️",
      children: [
        { title: "ثبت سریال قطعه", path: "/production/serialization/register", icon: "🏷️" },
        { title: "سشن‌های پالت ایستگاه", path: "/production/serialization/feed-sessions", icon: "📦" },
        { title: "ردیابی کامل سریال", path: "/production/serialization/trace", icon: "🔍" },
        { title: "محصولات متأثر (Recall)", path: "/production/serialization/affected-units", icon: "⚠️" },
      ]
    },
    {
      key: "inventory",
      title: "مدیریت انبارداری",
      icon: "📦",
      children: [
        { title: "پیش‌خوان انبار", path: "/inventory", icon: "📊" },
        { title: "خانواده متریال‌ها", path: "/inventory/materials", icon: "🏷️" },
        { title: "انبارها و مکان‌ها", path: "/inventory/warehouses", icon: "🏭" },
        { title: "تراکنش‌های موجودی", path: "/inventory/stock", icon: "⚖️" },
        { title: "پالت‌ها (Lots)", path: "/inventory/lots", icon: "📦" },
      ]
    },
    {
      key: "import_labeling",
      title: "ابزارهای ورودی و برچسب",
      icon: "🖨️",
      children: [
        { title: "ورود اکسل متریال", path: "/inventory/materials/import", icon: "📥" },
        { title: "ورود اکسل رسید انبار", path: "/inventory/stock-receipts/import", icon: "📋" },
        { title: "تنظیمات برچسب", path: "/inventory/label-settings", icon: "🖨️" },
        { title: "چاپ گروهی برچسب", path: "/inventory/print-batch", icon: "📑" },
      ]
    },
    {
      key: "planning",
      title: "برنامه‌ریزی تولید",
      icon: "📅",
      children: [
        { title: "پیش‌خوان برنامه‌ریزی", path: "/planning", icon: "📊" },
        { title: "برنامه جامع تولید (MPS)", path: "/planning/master-schedules", icon: "🗓️" },
        { title: "اجراهای MRP", path: "/planning/mrp-runs", icon: "⚙️" },
        { title: "بررسی ظرفیت (Capacity)", path: "/planning/capacity-check", icon: "⚖️" },
      ]
    },
    {
      key: "quality",
      title: "کنترل کیفیت (QC)",
      icon: "🛡️",
      children: [
        { title: "پیش‌خوان کیفیت", path: "/quality", icon: "📊" },
        { title: "خانواده‌های چک‌لیست", path: "/quality/families", icon: "📑" },
        { title: "سوابق بازرسی", path: "/quality/inspections", icon: "🔍" },
        { title: "ثبت بازرسی جدید", path: "/quality/inspections/new", icon: "➕" },
      ]
    },
    {
      key: "forms_workflow_reports",
      title: "فرم‌ها، کارتابل و گزارش‌ها",
      icon: "📝",
      children: [
        { title: "خانواده‌های فرم", path: "/forms/families", icon: "📑" },
        { title: "فرم‌های پر شده", path: "/forms/instances", icon: "📥" },
        { title: "صندوق تأیید (Inbox)", path: "/workflow/inbox", icon: "📥" },
        { title: "تعاریف گزارش‌ها", path: "/reporting", icon: "📊" },
        { title: "طراحی قالب چاپ", path: "/printing", icon: "🖼️" },
      ]
    },
    {
      key: "marketplace_org",
      title: "بازارچه و پیکربندی سازمان",
      icon: "🛒",
      children: [
        { title: "پیش‌خوان بازارچه", path: "/marketplace", icon: "🏪" },
        { title: "آگهی‌های فروش", path: "/marketplace/listings", icon: "📢" },
        { title: "کاتالوگ و فروشگاه‌ها", path: "/marketplace/catalog", icon: "📚" },
        { title: "پیکربندی سازمان", path: "/organization/hierarchy", icon: "🏢" },
      ]
    },
    {
      key: "support",
      title: "پشتیبانی و راهنما",
      icon: "🎧",
      children: [
        { title: "ثبت تیکت پشتیبانی", path: "/support/tickets/new", icon: "🎫" },
        { title: "کارتابل پشتیبانی", path: "/remote-assist", icon: "🤝" },
      ]
    },
  ];

  const filteredMenuItems = menuItems.filter(item => {
    if (item.key === "inventory" || item.key === "import_labeling") return hasInvPerm;
    if (item.key === "orders_lines" || item.key === "product_bom" || item.key === "shopfloor_shifts" || item.key === "material_holds" || item.key === "serialization") return hasProdPerm;
    if (item.key === "quality") return hasQualPerm;
    if (item.key === "planning") return hasPlanPerm;
    return true; // default open (organization, marketplace, support, forms)
  });

  return (
    <div className="app-layout-wrapper" style={{ display: "flex", flexDirection: "column", height: "100vh", overflow: "hidden", fontFamily: "var(--font-family-fa)" }}>
      {/* Styles block for local animations/styles */}
      <style>{`
        @media print {
          .app-layout-wrapper, .app-layout-content, main {
            height: auto !important;
            overflow: visible !important;
            display: block !important;
          }
          /* Hide sidebar and topbar when printing */
          .app-sidebar, .app-topbar {
            display: none !important;
          }
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.1); opacity: 0.7; }
        }
        .sidebar-scroll::-webkit-scrollbar {
          width: 5px;
        }
        .sidebar-scroll::-webkit-scrollbar-track {
          background: transparent;
        }
        .sidebar-scroll::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 4px;
        }
        .sidebar-scroll::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.2);
        }
        .nav-link {
          display: flex;
          align-items: center;
          padding: 0.14rem 0.5rem;
          color: var(--color-text-on-dark);
          opacity: 0.85;
          border-radius: 6px;
          margin-bottom: 0.02rem;
          transition: all 0.2s ease;
          text-decoration: none;
          gap: 0.45rem;
          font-size: 0.84rem;
        }
        .nav-link:hover {
          background: rgba(255, 255, 255, 0.04);
          color: #4ade80;
          opacity: 1;
          transform: translateX(-2px);
        }
        .nav-link.active {
          background: linear-gradient(135deg, var(--color-primary), var(--color-accent));
          color: #ffffff;
          box-shadow: 0 4px 12px rgba(99, 102, 241, 0.25);
        }
        .tree-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0.16rem 0.5rem;
          color: var(--color-text-on-dark);
          opacity: 0.85;
          border-radius: 6px;
          margin-bottom: 0.02rem;
          cursor: pointer;
          transition: all 0.2s ease;
          gap: 0.45rem;
          font-size: 0.86rem;
        }
        .tree-header:hover {
          background: rgba(255, 255, 255, 0.04);
          color: #4ade80;
          opacity: 1;
        }
      `}</style>

      {/* Top Navbar */}
      <div className="app-topbar">
        <TopBar 
          isSidebarCollapsed={isSidebarCollapsed} 
          setIsSidebarCollapsed={setIsSidebarCollapsed} 
        />
      </div>

      {/* Main Area */}
      <div className="app-layout-content" style={{ display: "flex", flex: 1, overflow: "hidden", background: "transparent" }}>
        
        {/* Collapsible Tree Sidebar */}
        <div className="app-sidebar">
          <AppSidebar 
            isSidebarCollapsed={isSidebarCollapsed}
            menuItems={filteredMenuItems}
          />
        </div>

        {/* Content Panel */}
        <main style={{ flex: 1, overflowY: "auto", padding: "0.5rem 0.75rem", boxSizing: "border-box", direction: "rtl", order: 2 }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
